import React, { useEffect, useRef, useState } from "react";
import { Box, Card, CardContent, CircularProgress } from "@mui/material";
import Div from "@jumbo/shared/Div/Div";
import JumboTextField from "@jumbo/components/JumboFormik/JumboTextField";
import { LoadingButton } from "@mui/lab";
import SweetAlert from "app/Common/SweetAlert";
import { ASSET_IMAGES } from "app/utils/constants/paths";
import { Link, useNavigate } from "react-router-dom";
import { getAssetPath } from "app/utils/appHelpers";
import { alpha } from "@mui/material/styles";
import * as yup from "yup";
import { Form, Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import {
  validateResetPasswordToken,
  updateResetPasswordThunk,
} from "app/store/slice/login-slice";

import { unwrapResult } from "@reduxjs/toolkit";
const validationSchema = yup.object({
  password: yup
    .string("")
    .required("Password is required")
    .min(6, "Password must be minimum 6 characters"),
  retypepassword: yup
    .string("")
    .required("Retype Password is required")
    .oneOf(
      [yup.ref("password"), null],
      "Password and Retype password does not matched"
    ),
});

const ResetPassword = () => {
  const ToastRef = useRef();
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [userId, setUserId] = useState("");
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const token = params.get("token");
  const { resetPasswordLoader } = useSelector((state) => state.LoginReducer);
  const [tokenMsg, setMsgToken] = useState(null);
  const [showForm, setShowForm] = useState(false);
  useEffect(() => {
    if (token != "" && token != undefined && token != null) {
      dispatch(validateResetPasswordToken({ token: token }))
        .then(unwrapResult)
        .then((res) => {
          if (res.data.success) {
            setShowForm(true);
            setUserId(res.data.user_id);
          } else {
            setMsgToken(false);
            //ToastRef.current.showSweetAlerts("error", res.data.message);
          }
        });
    } else {
      navigate("/login");
    }
  }, []);

  const onResetPassword = (password) => {
    setSubmitting(true);

    dispatch(
      updateResetPasswordThunk({
        user_id: userId,
        new_password: password,
        user_token: token,
      })
    )
      .then(unwrapResult)
      .then((res) => {
        if (res.data.success == true) {
          setMsgToken(true);
          setShowForm(false);
        } else {
          ToastRef.current.showSweetAlerts("error", res.data.message);
        }
        setSubmitting(false);
      });
  };
  const cancelHandler = () => {
    navigate("/login");
  };

  const currentDomain = window.location.hostname;
  let loginBackgroundImage = "";
  if (currentDomain.indexOf("adfuel.us") != -1) {
    loginBackgroundImage = ASSET_IMAGES + "/Login_Background_adfuel.png";
  } else if (currentDomain.indexOf("contextnetworks.net") != -1) {
    loginBackgroundImage = ASSET_IMAGES + "/Login_Background_context.png";
  } else if (currentDomain.indexOf("savvydsp.com") != -1) {
      loginBackgroundImage = ASSET_IMAGES + "/savvy_media.png";
  } else if (currentDomain.indexOf("perfectaudience.io") != -1) {
        loginBackgroundImage = ASSET_IMAGES + "/Perfect_Audience.png";
  } else if (currentDomain.indexOf("arrowmarketinglabs.com") != -1) {
        loginBackgroundImage = ASSET_IMAGES + "/arrow_marketing.png";
  } else {
    loginBackgroundImage = ASSET_IMAGES + "/Login_Background.jpg";
  }

  return (
    <Div
      sx={{
        width: 720,
        maxWidth: "100%",
        margin: "auto",
        p: 4,
      }}
    >
      <Card
        sx={{
          display: "flex",
          minWidth: 0,
          flexDirection: { xs: "column", md: "row" },
        }}
      >
        <CardContent
          sx={{
            flex: "0 1 300px",
            position: "relative",
            background: `${
              currentDomain.indexOf("contextnetworks.net") != -1
                ? "#000"
                : currentDomain.indexOf("savvydsp.com") != -1
                ? "#ffffff"
                : currentDomain.indexOf("arrowmarketinglabs.com") != -1
                ? "#ffffff"
                : currentDomain.indexOf("perfectaudience.io") != -1
                ? "#ffffff"
                : "#0267a0"
            } url(${getAssetPath(
              loginBackgroundImage,
              "640x428"
            )}) no-repeat center`,
            backgroundSize:
              currentDomain.indexOf("contextnetworks.net") != -1 ||
              currentDomain.indexOf("savvydsp.com") != -1 ||
              currentDomain.indexOf("arrowmarketinglabs.com") != -1 ||
              currentDomain.indexOf("perfectaudience.io") != -1
                ? "contain"
                : "cover",

            "&::after": {
              display: "inline-block",
              position: "absolute",
              content: `''`,
              inset: 0,
              backgroundColor:
                currentDomain.indexOf("adfuel.us") != -1 ||
                currentDomain.indexOf("contextnetworks.net") != -1 ||
                currentDomain.indexOf("savvydsp.com") != -1 ||
                currentDomain.indexOf("arrowmarketinglabs.com") != -1 ||
                currentDomain.indexOf("perfectaudience.io") != -1
                  ? "transparent"
                  : alpha("#0267a0", 0.65),
            },
            minHeight: "300px",
          }}
        >
          <Div
            sx={{
              display: "flex",
              minWidth: 0,
              flex: 1,
              flexDirection: "column",
              color: "common.white",
              position: "relative",
              zIndex: 1,
              height: "100%",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Div
              sx={{
                display:
                  currentDomain.indexOf("advangelists.com") != -1 ? "" : "none",
              }}
            >
              <Link href="#" underline="none" sx={{ display: "inline-flex" }}>
                <img
                  src={`${ASSET_IMAGES}/newlogo_white.png`}
                  alt="Mobiquity React"
                  height="50px"
                />
              </Link>
            </Div>
          </Div>
        </CardContent>

        <CardContent sx={{ flex: 1, p: 4, minHeight: "300px" }}>
          <Div sx={{ mb: 2, fontSize: "20px" }}>Reset Password</Div>
          {token != null && token != undefined && resetPasswordLoader && (
            <Div sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
              <CircularProgress />
            </Div>
          )}
          {tokenMsg == true && (
            <Div sx={{ fontSize: "16px" }}>
              <Box>Your Password updated sucessfully!</Box>
              <Box>
                Please click <Link to="/login">here</Link> to login.
              </Box>
            </Div>
          )}
          {tokenMsg == false && (
            <Div sx={{ fontSize: "16px", color: "red" }}>
              <Box>This reset password link is invalid.</Box>
              <Box>
                Please click <Link to="/login">here</Link> to login.
              </Box>
            </Div>
          )}

          {showForm && (
            <Formik
              validateOnChange={true}
              initialValues={{
                password: "",
                retypepassword: "",
              }}
              validationSchema={validationSchema}
              onSubmit={(data) => {
                onResetPassword(data.password);
              }}
            >
              {(props) => (
                <Form
                  style={{ textAlign: "left" }}
                  noValidate
                  autoComplete="off"
                  onSubmit={props.handleSubmit}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      props.handleSubmit();
                    }
                  }}
                >
                  <Div sx={{ mt: 1, mb: 3 }}>
                    <JumboTextField
                      fullWidth
                      name="password"
                      label="Password"
                      autoComplete="off"
                      type="password"
                    />
                  </Div>
                  <Div sx={{ mt: 1, mb: 2 }}>
                    <JumboTextField
                      fullWidth
                      name="retypepassword"
                      label="Retype Password"
                      type="password"
                    />
                  </Div>
                  <Div sx={{ flexDirection: "row" }}>
                    <LoadingButton
                      type="submit"
                      variant="contained"
                      size="medium"
                      loading={submitting}
                      sx={{ mr: 2, width: "48%" }}
                    >
                      Submit
                    </LoadingButton>
                    <LoadingButton
                      variant="outlined"
                      size="medium"
                      onClick={cancelHandler}
                      sx={{ width: "45%" }}
                    >
                      Cancel
                    </LoadingButton>
                  </Div>
                </Form>
              )}
            </Formik>
          )}
        </CardContent>
      </Card>

      <SweetAlert ref={ToastRef} />
    </Div>
  );
};

export default ResetPassword;
